import {EChannelType, TItemId} from 'src/constants';
import {ELicenseStatus} from 'src/containers/Licenses/definitions';

type TSubjectLicense = {
  id: number;
  name: string;
  channelType: EChannelType;
  status: ELicenseStatus;
  expiredAt?: string;
  createdAt?: string;
  activatedAt?: string;
  cancelledAt?: string;
  paidUntil?: string;
  scheduledCancelAt?: string;
  activeUntil?: string;
  temporaryblockedAt?: string;
  subjectId?: TItemId;
};

const LICENSE_CHANNELS: EChannelType[] = [
  EChannelType.WHATSAPP,
  EChannelType.SMS,
  EChannelType.VIBER,
  EChannelType.MAX_BOT,
  EChannelType.MAX,
  EChannelType.TELEGRAM,
];

export type {TSubjectLicense};
export {LICENSE_CHANNELS};
